module.exports = __webpack_public_path__ + "img/grend_1.06fa3dec.jpg";